import React from "react";
import Hotel from "./Images/Hotel-logo.png";

const Heading = () => {
  return (
    <header className="App-header">
      <img src={Hotel} className="App-logo" />
      <p>HOTEL APPOLIN</p>
    </header>
  );
};

export default Heading;
